module.exports = __webpack_public_path__ + "static/img/spinner.d784e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.png
// module id = gbWw
// module chunks = 1